var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.19641,
    y: 1.79462,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "url(#paint0_linear_1463_637)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7244 10.3682C20.7975 10.4178 20.8588 10.48 20.9051 10.5509C20.9513 10.6219 20.9814 10.7004 20.9938 10.7818C21.0061 10.8632 21.0004 10.946 20.977 11.0255C20.9536 11.1049 20.913 11.1795 20.8574 11.2448L13.4192 19.9951C13.3588 20.066 13.2823 20.1245 13.1946 20.1667C13.107 20.2088 13.0103 20.2337 12.9111 20.2396C12.8118 20.2456 12.7123 20.2324 12.6192 20.201C12.5261 20.1696 12.4416 20.1207 12.3713 20.0576L8.18728 16.3075C8.0641 16.189 7.99704 16.0323 8.00023 15.8704C8.00342 15.7085 8.0766 15.554 8.20437 15.4395C8.33213 15.3249 8.5045 15.2594 8.68516 15.2565C8.86581 15.2536 9.04066 15.3137 9.17285 15.4241L12.7934 18.6684L19.7482 10.4873C19.8601 10.3556 20.0258 10.2691 20.2088 10.2467C20.3918 10.2244 20.5773 10.2681 20.7244 10.3682Z",
    fill: "url(#paint1_linear_1463_637)",
    stroke: "url(#paint2_linear_1463_637)",
    strokeWidth: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1463_637",
    x1: 14.6964,
    y1: 0.794617,
    x2: 14.6964,
    y2: 29.7946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AB1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1463_637",
    x1: 14.5001,
    y1: 10.241,
    x2: 14.5001,
    y2: 20.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AB1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1463_637",
    x1: 14.5001,
    y1: 10.241,
    x2: 14.5001,
    y2: 20.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AB1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.398a4b8a36e01283a795389362f5d184.svg";
export { ForwardRef as ReactComponent };